export const getFileNameFromContentDisposition = (contentDisposition?: string | null) => {
  if (!contentDisposition) return undefined

  const utf8FileName = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1]
  if (utf8FileName) {
    try {
      return decodeURIComponent(utf8FileName)
    } catch {
      return utf8FileName
    }
  }

  return contentDisposition.match(/filename="?([^";]+)"?/i)?.[1]
}
